export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: "Países en los que el organismo solicitante emite o tiene previsto emitir certificados",
                    type: 'text',
                    key: 'countries_issues_certificates',
                },
                {
                    title: "Países en los que el organismo solicitante opera desde una ubicación fija que realiza alguna actividad de certificación",
                    type: 'text',
                    key: 'countries_certification_activities_fixed',
                },
                {
                    title: "Países en los que el organismo solicitante tiene personal remoto que realiza(rá) alguna actividad de certificación",
                    type: 'text',
                    key: 'countries_certification_activities_remote',
                },
                {
                    title: "Países en los que el organismo solicitante tiene acuerdos para gestionar las actividades que se realizan desde oficinas fijas extranjeras o que realiza personal remoto",
                    type: 'text',
                    key: 'countries_certification_activities_fixed_remote',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}